"use strict";
var DerivedField_1;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const data_field_1 = require("../data-field");
const lodash_1 = require("lodash");
const core_decorators_1 = require("core-decorators");
const covariate_1 = require("../covariate/covariate");
const undefined_1 = require("../../../util/undefined");
const errors_1 = require("../../errors");
const pmml_functions_1 = tslib_1.__importDefault(require("./pmml-functions"));
const datum_1 = require("../../data/datum");
const debug_risk_1 = require("../../../debug/debug-risk");
// tslint:disable-next-line:only-arrow-functions
const getValueFromTable = function (table, outputColumn, conditions) {
    const conditionTableColumns = Object.keys(conditions);
    return undefined_1.throwErrorIfUndefined(table.find(row => {
        const unMatchedColumn = conditionTableColumns.find(conditionColumn => {
            // tslint:disable-next-line
            return row[conditionColumn] != conditions[conditionColumn];
        });
        return unMatchedColumn === undefined ? true : false;
    }), new errors_1.NoTableRowFoundError(conditions))[outputColumn];
};
function getLeafFieldsForDerivedField(derivedField) {
    if (derivedField.derivedFrom.length === 0) {
        return [derivedField];
    }
    else {
        return lodash_1.flatten(derivedField.derivedFrom.map(derivedFromItem => {
            if (derivedFromItem instanceof DerivedField) {
                return getLeafFieldsForDerivedField(derivedFromItem);
            }
            else if (derivedFromItem instanceof covariate_1.Covariate) {
                if (derivedFromItem.derivedField) {
                    return getLeafFieldsForDerivedField(derivedFromItem.derivedField);
                }
                else {
                    return derivedFromItem;
                }
            }
            else {
                return derivedFromItem;
            }
        }));
    }
}
exports.getLeafFieldsForDerivedField = getLeafFieldsForDerivedField;
let DerivedField = DerivedField_1 = class DerivedField extends data_field_1.DataField {
    constructor(derivedFieldJson, derivedFrom) {
        super(derivedFieldJson);
        this.name = derivedFieldJson.name;
        this.equation = derivedFieldJson.equation;
        this.derivedFrom = derivedFrom;
    }
    evaluateEquation(obj, userFunctions, tables) {
        // tslint:disable-next-line
        obj;
        // tslint:disable-next-line
        userFunctions;
        // tslint:disable-next-line
        tables;
        // tslint:disable-next-line
        let derived = undefined;
        // tslint:disable-next-line
        let func = pmml_functions_1.default;
        // tslint:disable-next-line
        func;
        func['getValueFromTable'] = getValueFromTable;
        eval(this.equation);
        return derived;
    }
    calculateCoefficent(data, userDefinedFunctions, tables) {
        /*Check if there is a datum for this intermediate predictor. If there is then we don't need to go further*/
        const datumForCurrentDerivedField = this.getDatumForField(data);
        if (datumForCurrentDerivedField) {
            return datumForCurrentDerivedField.coefficent;
        }
        else {
            /*Filter out all the datum which are not needed for the equation evaluation*/
            let dataForEvaluation = data.filter(datum => this.derivedFrom.find(derivedFromItem => derivedFromItem.name === datum.name)
                ? true
                : false);
            /*If we don't have all the data for evaluation when calculate it*/
            if (dataForEvaluation.length !== this.derivedFrom.length) {
                dataForEvaluation = this.calculateDataToCalculateCoefficent(data, userDefinedFunctions, tables);
            }
            /*make the object with the all the data needed for the equation evaluation*/
            const obj = {};
            dataForEvaluation.forEach(datum => {
                obj[datum.name] = datum.coefficent;
            });
            const evaluatedValue = this.evaluateEquation(obj, userDefinedFunctions, tables);
            let returnedCalculatedValue;
            // null or an empty string are coerced to 0 when passed through the Number function in the next statement. This statement will reset them to undefined so that any further manipulations in upstream fields will always return undefined.
            if (evaluatedValue === null ||
                (typeof evaluatedValue === 'string' &&
                    evaluatedValue.trim().length === 0)) {
                returnedCalculatedValue = undefined;
            }
            // To handle cases where the value is '1', '2' etc.
            else if (isNaN(Number(evaluatedValue)) === false) {
                returnedCalculatedValue = Number(evaluatedValue);
            }
            else if (typeof evaluatedValue === 'string') {
                returnedCalculatedValue = evaluatedValue;
            }
            else {
                returnedCalculatedValue = this.formatCoefficient(evaluatedValue);
            }
            debug_risk_1.debugRisk.addFieldDebugInfo(this.name, returnedCalculatedValue);
            return returnedCalculatedValue;
        }
    }
    calculateDataToCalculateCoefficent(data, userDefinedFunctions, tables) {
        /*Go through each explanatory predictor and calculate the coefficent for
        each which will be used for the evaluation*/
        return lodash_1.flatten(this.derivedFrom.map(derivedFromItem => {
            const datumFound = derivedFromItem.getDatumForField(data);
            if (datumFound) {
                return [datumFound];
            }
            if (derivedFromItem instanceof covariate_1.Covariate) {
                return datum_1.datumFactoryFromDataField(derivedFromItem, derivedFromItem.calculateCoefficient(data, userDefinedFunctions, tables));
            }
            else if (derivedFromItem instanceof DerivedField_1) {
                return datum_1.datumFactoryFromDataField(derivedFromItem, derivedFromItem.calculateCoefficent(data, userDefinedFunctions, tables));
            }
            else {
                return {
                    name: derivedFromItem.name,
                    coefficent: undefined,
                };
            }
        }));
    }
    getDescendantFields() {
        return data_field_1.DataField.getUniqueDataFields(lodash_1.flatten(this.derivedFrom.map(derivedFromItem => {
            if (derivedFromItem instanceof covariate_1.Covariate) {
                if (derivedFromItem.derivedField) {
                    return derivedFromItem.derivedField
                        .getDescendantFields()
                        .concat(derivedFromItem);
                }
                else {
                    return derivedFromItem;
                }
            }
            else if (derivedFromItem instanceof DerivedField_1) {
                return derivedFromItem
                    .getDescendantFields()
                    .concat(derivedFromItem);
            }
            else {
                return derivedFromItem;
            }
        })));
    }
};
DerivedField = DerivedField_1 = tslib_1.__decorate([
    core_decorators_1.autobind,
    tslib_1.__metadata("design:paramtypes", [Object, Array])
], DerivedField);
exports.DerivedField = DerivedField;
//# sourceMappingURL=derived-field.js.map